import { createSelector } from "reselect"
import { first, get, chain } from "lodash"
import { getRawSelectedPositionSet, getSmartTradeMeta } from "."
import { getRefInstrument } from "modules/research-topic/selectors/instrument"

const EMPTY_OBJECT = {}
const getBasketSummary = (state) => get(state, "global.data.smartTradePanelBasket.data.model.simulation.basketSummary.0", EMPTY_OBJECT)

const getBasketPositions = createSelector(
  [getBasketSummary],
  (basketSummary) => {
    const { gmv, positions } = basketSummary
    const calculateEconomicExposure = (economicExposure, gmv) => economicExposure * gmv / 100

    const basketPositions = chain(positions)
      .reduce((positions, { assetClass, id, modelProviderId, internalId, economicExposure }) => {
        if (assetClass === "equity") {
          return {
            ...positions,
            equities: [...positions.equities, {
              id: { modelProviderId, internalId },
              economicExposure: calculateEconomicExposure(economicExposure, gmv),
            }],
          }
        } else if (assetClass === "index") {
          return {
            ...positions,
            indexes: [...positions.indexes, {
              id,
              economicExposure: calculateEconomicExposure(economicExposure, gmv),
            }],
          }
        }
        return positions
      }, { equities: [], indexes: [] })
      .value()

    return basketPositions
  },
)

export const getSelectedExperimentPositionSet = createSelector(
  [getRawSelectedPositionSet, getRefInstrument, getBasketPositions],
  (rawSelectedPositionSet, instrument, basketPositions) => {
    if (!instrument) { return null }
    const positionSet = first(rawSelectedPositionSet)
    return {
      ...positionSet,
      ...basketPositions,
    }
  },
)

export const getSelectedExperimentConfig = createSelector(
  [getSmartTradeMeta],
  (meta) => meta ? ({
    modelId: meta.modelId,
    type: meta.type,
    ...meta.config,
  }) : null,
)
